export default __webpack_public_path__ + "island1.b713df2152bbaaa36bcf28122d8a6a80.png";